import type { DropdownItemColors } from '@/dsComponents/Dropdown/types';

export enum CompanyNeedPriority {
	NONE = 'NONE',
	LOW = 'LOW',
	MEDIUM = 'MEDIUM',
	HIGH = 'HIGH',
	HIGHEST = 'HIGHEST',
}

export interface CompanyNeedPriorityInfo {
	label: string;
	value: CompanyNeedPriority;
	icon?: string;
	color?: DropdownItemColors;
}
